import { useDispatch, useSelector } from "react-redux";
import useCrypto from "./crypto";
import { isEmpty } from 'lodash';
import DefaultUser from '../../assets/images/default-user.svg';

function useKidListFunctionality() {
    const { user } = useSelector(({ auth }) => auth);
    const dispatch = useDispatch();
    const { encodeNumberToBase64 } = useCrypto();

    // Check and set the image prefix URL with explicit fallback
    const imgPrefixUrl = process.env.REACT_APP_AMAZON_S3_IMAGE_URL_PREFIX_NEW;

    function getImage(image, gender) {
        if (isEmpty(image) || image === 'NaN') {
            if (gender === 'Male') {
                return `${imgPrefixUrl}/assets/boy.png`;
            } else if (gender === 'Female') {
                return `${imgPrefixUrl}/assets/girl.png`;
            } else {
                return DefaultUser;
            }
        } else {
            const path = `${imgPrefixUrl}/${encodeNumberToBase64(user?.ID)}/ProfilesPics/${image}`;
            return path;
        }
    }

    return { getImage, dispatch };
}

export default useKidListFunctionality;
